import { Image } from '@wix/image';
export default Image;
//# sourceMappingURL=Image.js.map